// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from '../get-merchant-config';

export function shouldDisableEmailOverride(merchant: Merchant): boolean {
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig
    ? Boolean(merchantConfig.disable_email_override)
    : false;
}
